
import axios from "axios";
import CommonApi from "./CommonApi";

export default class ToDoApi {

    static getBaseUrl() {
        return CommonApi.getHost().replace(/\/$/, "");
    }

    static checkResponse(response) {
        const data = response.data;

        if (data?.Status === false) {
            throw new Error(
                data.Error ||
                data.error ||
                "Ошибка API ToDo"
            );
        }

        return data;
    }

    static createFormData(fields = {}, photos = []) {
        const data = new FormData();

        Object.entries(fields).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                data.append(key, String(value));
            }
        });

        photos.forEach((item, index) => {
            const file = item?.blob ?? item;

            if (!(file instanceof Blob)) {
                throw new Error(
                    "Фотография должна быть Blob или File"
                );
            }

            const extensions = {
                "image/png": "png",
                "image/webp": "webp",
                "image/jpeg": "jpg"
            };

            const ext = extensions[file.type] || "jpg";

            const name = file instanceof File
                ? file.name
                : `photo-${index + 1}.${ext}`;

            data.append("photos", file, name);
        });

        return data;
    }

    // Получить задания
    static async getTasks(
        house = "",
        status = "all",
        signal
    ) {
        const res = await axios.get(
            `${this.getBaseUrl()}/ToDo/getTasks`,
            {
                params: {
                    ...(house ? { house } : {}),
                    status
                },
                signal
            }
        );

        return this.checkResponse(res);
    }

    // Получить одно задание
    static async getTask(id) {
        const res = await axios.get(
            `${this.getBaseUrl()}/ToDo/getTask/${encodeURIComponent(id)}`
        );

        return this.checkResponse(res);
    }

    // Создать задание
    static async addTask(task, photos = []) {
        const formData = this.createFormData({
            house: task.house,
            comment: task.comment,
            author: task.author,
            date: task.date
        }, photos);

        const res = await axios.post(
            `${this.getBaseUrl()}/ToDo/addTask`,
            formData
        );

        return this.checkResponse(res);
    }

    // Добавить фотографии к заданию
    static async addPhotos(id, photos = []) {
        const formData = this.createFormData({}, photos);

        const res = await axios.post(
            `${this.getBaseUrl()}/ToDo/addPhotos/${encodeURIComponent(id)}`,
            formData
        );

        return this.checkResponse(res);
    }

    // Выполнить задание с фото результата
    static async completeTask(id, photos = []) {
        const formData = this.createFormData({}, photos);

        const res = await axios.patch(
            `${this.getBaseUrl()}/ToDo/completeTask/${encodeURIComponent(id)}`,
            formData
        );

        return this.checkResponse(res);
    }

    // Вернуть задание в Offen
    static async reopenTask(id) {
        const res = await axios.patch(
            `${this.getBaseUrl()}/ToDo/reopenTask/${encodeURIComponent(id)}`
        );

        return this.checkResponse(res);
    }

    // Удалить задание
    static async deleteTask(id) {
        const res = await axios.delete(
            `${this.getBaseUrl()}/ToDo/deleteTask/${encodeURIComponent(id)}`
        );

        return this.checkResponse(res);
    }

    // Получить полный URL фотографии
    static getPhotoUrl(photo) {
        const raw = typeof photo === "string"
            ? photo
            : photo?.url;

        if (!raw) return "";

        return new URL(
            raw,
            `${this.getBaseUrl()}/`
        ).href;
    }

    // Старый метод сохранён для совместимости
    static async addImage(image, house, floor) {
        const formData = new FormData();

        formData.append("image", image, "1.jpg");
        formData.append("house", house);
        formData.append("floor", floor);

        const res = await axios.post(
            `${this.getBaseUrl()}/ToDo/addImage`,
            formData
        );

        return this.checkResponse(res);
    }
}
